<template>
    <div class="qksm qksm7 page">
        <h4>七、关于一般公共预算“三公”经费支出预算表的说明</h4>
        <div class="nogap">
            <p class="hide_pdf">
                （是否是{{$parent.year}}年新增单位<reason type="select" classname="qksm select " name="新增单位" v-model:value="qksm['新增单位']" optionarr="请选择,是,否"></reason>）<br />
                <template v-if="qksm['新增单位']=='是'">
                    （新增单位为市、区、县级<reason type="select" classname="qksm select " name="新增单位级" v-model:value="qksm['新增单位级']" optionarr="请选择,市,区,县"></reason>）
                    <br />
                </template>
            </p>
            <p>
                {{$parent.year}}年{{$store.state.divData.divname}}通过一般公共预算财政拨款安排的“三公”经费预算共{{isMoney(T7.总计)}}万元，
                <span class="hide_pdf" v-if="qksm['新增单位']!='是'">
                    （去年预算数{{isMoney(T7.总计last)}}万元）
                </span>
                <span v-if="qksm['新增单位']=='是'">
                    <span v-if="num(T7.总计)==0">主要原因是{{$parent.year-1}}年、{{$parent.year}}年本{{$parent.typeText}}均未使用一般公共预算拨款安排“三公”经费支出。</span>
                    <span v-else>全部为新增支出，主要原因是本{{$parent.typeText}}为{{$parent.year}}年新增{{qksm['新增单位级']}}级部门预算单位，上年无“三公”经费预算。</span>
                </span>
                <span v-else-if="num(T7.总计)==num(T7['总计last'])">
                    <span v-if="num(T7.总计)==0">
                        主要原因是{{$parent.year-1}}年、{{$parent.year}}年本{{$parent.typeText}}均未使用一般公共预算拨款安排“三公”经费支出。
                    </span>
                    <span v-else>
                        与上年持平。
                    </span>
                </span>
                <span v-else-if="growthRatioNum(T7.总计,T7['总计last'])<10 && num(T7['总计last']) > 0">
                    与上年基本持平。
                </span>
                <span v-else>
                    比上年{{growthValueText(T7.总计,T7['总计last'])}}万元
                    <span v-if="num(T7['总计last'])==0">
                        （去年预算数为0万元，无法计算增减比率）。
                    </span>
                    <span v-else>
                        ，{{growthRatioText(T7.总计,T7['总计last'])}}。
                    </span>
                    主要原因是<reason type="textarea" classname="qksm widest because" name="T7原因" v-model:value="qksm['T7原因']"></reason>
                </span>
            </p>
            <p>
                其中：
                <template v-for="(item, idx) in T7.items">
                    <template v-if="item.name=='公务用车'">
                        公务用车购置及运行费{{isMoney(item.value)}}万元，包括
                    </template>
                    <template v-else>
                        {{item.name}}{{isMoney(item.value)}}万元，
                        <span class="hide_pdf" v-if="qksm['新增单位']!='是'">
                            （去年预算数{{isMoney(item.lastvalue)}}万元）
                        </span>
                        <span v-if="qksm['新增单位']=='是'">
                            <span v-if="num(item.value)==0">主要原因是{{$parent.year-1}}年、{{$parent.year}}年本{{$parent.typeText}}均未使用一般公共预算拨款安排“{{item.name.replace("费","")}}”经费支出</span>
                            <span v-else>全部为新增支出，主要原因是本{{$parent.typeText}}为{{$parent.year}}年新增{{qksm['新增单位级']}}级部门预算单位，上年无“{{item.name.replace("费","")}}”经费预算</span>
                        </span>
                        <span v-else-if="num(item.value)==num(item.lastvalue)">
                            <span v-if="num(item.value)==0">
                                主要原因是{{$parent.year-1}}年、{{$parent.year}}年本{{$parent.typeText}}均未使用一般公共预算拨款安排“{{item.name.replace("费","")}}”经费支出
                            </span>
                            <span v-else>
                                与上年持平
                            </span>
                        </span>
                        <span v-else-if="growthRatioNum(item.value,item.lastvalue)<10 && num(T7['总计last']) > 0">
                            与上年基本持平
                        </span>
                        <span v-else>
                            比上年{{growthValueText(item.value,item.lastvalue)}}万元
                            <span v-if="num(item.lastvalue)==0">
                                （去年预算数为0万元，无法计算增减比率）。
                            </span>
                            <span v-else>
                                ，{{growthRatioText(num(item.value),num(item.lastvalue))}}。
                            </span>
                            主要原因是<reason type="textarea" classname="qksm because" :name="'T7原因'+item.name" v-model:value="qksm['T7原因'+item.name]"></reason>
                        </span>
                        {{item.name=='公务用车购置费' ? '；' : '。'}}
                    </template>
                </template>
            </p>
        </div>
        <p></p>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm7",
        props: {
            T7: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm;
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },

    };
</script>